import { TranslationUploadWarning } from '../types/working-model';
import { GetTranslationService, PutTranslationService } from './helpers';

export const getTranslationFile = async (token: string, eventUuid: string): Promise<any> => {
	return GetTranslationService(`/translation/${eventUuid}?v=${Date.now()}`, token);
};

const makeTranslationFileUploadRequest = (token: string, formData: FormData, eventUuid: string, language: string): Promise<{ warnings: TranslationUploadWarning[], manifests: Record<string, string> }> =>
	new Promise((resolve, reject) => {
		const request = new XMLHttpRequest();
		request.open('PUT', `${process.env.REACT_APP_TRANSLATIONS_SERVICE_HOST}/translation/${eventUuid}/${language}`);
		request.setRequestHeader('bl-token', token);

		request.onload = function() {
			const response = request.response ? JSON.parse(request.response) : { message: 'Error processing input' };
			if (this.status >= 200 && this.status < 300) {
				resolve(JSON.parse(request.response));
			} else {
				reject({
					status: this.status,
					statusText: request.statusText,
					error: response
				});
			}
		};
		request.onerror = function() {
			const response = request.response ? JSON.parse(request.response) : { message: 'Error processing input' };
			reject({
				status: this.status,
				statusText: request.statusText,
				error: response
			});
		};

		request.send(formData);
	});

export const uploadTranslationFile = async (token: string, file: File, eventUuid: string, language: string): Promise<{ warnings: TranslationUploadWarning[], manifests: Record<string, string> }> => {
	const formData = new FormData();
	formData.append('file', file);

	return await makeTranslationFileUploadRequest(token, formData, eventUuid, language);
};

export const saveTranslationFile = async (token: string, eventUuid: string): Promise<boolean> => {
	return await PutTranslationService(`/translation/${eventUuid}/save`, token);
};